import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=647a5fb6&scoped=true&"
import script from "./ChatRoom.vue?vue&type=script&lang=js&"
export * from "./ChatRoom.vue?vue&type=script&lang=js&"
import style0 from "./ChatRoom.vue?vue&type=style&index=0&id=647a5fb6&scope=true&lang=scss&scoped=true&"
import style1 from "./ChatRoom.vue?vue&type=style&index=1&id=647a5fb6&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647a5fb6",
  null
  
)

export default component.exports